import theme from "@shared/utils/themeColors";
import { useState } from "react";

function SidebarLinkGroup({
  children,
  activecondition = false,
  initialOpen = false,
}) {
  const [open, setOpen] = useState(activecondition || initialOpen);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <li
      className={`pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0 bg-[linear-gradient(135deg,var(--tw-gradient-stops))] ${
        activecondition && theme.bg.gradientPrimary
      }`}
    >
      {children(handleClick, open)}
    </li>
  );
}

export default SidebarLinkGroup;
